
import Vue from 'vue'

global['________'] = true;
delete global['________'];
global.__uniConfig = {"tabBar":{"color":"#8a8a8a","selectedColor":"#2B8DE7","backgroundColor":"#F7F7F7","list":[{"text":"委托列表","pagePath":"paesEntrust/list/index","iconPath":"static/t1.png","selectedIconPath":"static/t2.png","redDot":false,"badge":""},{"text":"我的","pagePath":"pages/my/my","iconPath":"static/m1.png","selectedIconPath":"static/m2.png","redDot":false,"badge":""}],"borderStyle":"black"},"globalStyle":{"navigationBarTitleText":"在线投诉","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","backgroundColor":"#f6f6f6","titleNView":true},"easycom":{"autoscan":true,"custom":{"^u-(.*)":"uview-ui/components/u-$1/u-$1.vue","^u2-(.*)":"@/uview/u-$1/u-$1.vue","^bus-(.*)":"@/components/bus/$1/$1.vue","mescroll-empty":"@/components/w-list/mescroll-empty/mescroll-empty.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"condition":{"current":1,"list":[{"path":"/pages/assetDetail/assetDetail"}]},"navigateToMiniProgramAppIdList":["wx36fbd76c4c8c8dbf"]};
global.__uniConfig.compilerVersion = '3.1.22';
global.__uniConfig.router = {"mode":"hash","base":"/h5/"};
global.__uniConfig.publicPath = "/h5/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = "XVXBZ-NDMC4-JOGUS-XGIEE-QVHDZ-AMFV2";
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/var/jenkins_home/workspace/small-pl/xdd-cx-pts-h5/src/pages/index/index.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/var/jenkins_home/workspace/small-pl/xdd-cx-pts-h5/src/pages/index/list.vue')), 'pages-index-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/var/jenkins_home/workspace/small-pl/xdd-cx-pts-h5/src/pages/index/detail.vue')), 'pages-index-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-success', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/var/jenkins_home/workspace/small-pl/xdd-cx-pts-h5/src/pages/index/success.vue')), 'pages-index-success'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"在线投诉"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:44
}
},
{
path: '/pages/index/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"在线投诉"})
      },
      [
        createElement('pages-index-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/list',
  windowTop:44
}
},
{
path: '/pages/index/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"在线投诉"})
      },
      [
        createElement('pages-index-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/detail',
  windowTop:44
}
},
{
path: '/pages/index/success',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"在线投诉"})
      },
      [
        createElement('pages-index-success', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-success',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/success',
  windowTop:44
}
},
{
path: '/preview-image',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-preview-image', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'preview-image',
  pagePath:'/preview-image'
}
}
    ,
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
